<template>
    <div>
        <el-button type="primary" plain @click="returnPage">返回</el-button>
        <div class="border"></div>
        <el-form label-width="120px" ref="tableData" :model="tableData">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="专题名称">
                        <span>{{ tableData.topicName }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="专题颜色">
                           <el-color-picker v-model="tableData.topicColor" show-alpha  ></el-color-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-row>
                <el-col :span="12">
                    <el-form-item label="计划时间：">
                        <span>{{ tableData.couponStatus }} </span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="优惠券价格:">
                        <span>{{ tableData.couponMoney }}</span>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="专题图片">
                        <img :src="tableData.topicUrl"  class="avatar"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="border"></div>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="专题内容">
                        <div class="editorContainerInfo ql-editor activesImg" v-html="tableData.topicContent"></div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            url: '',
            id: '',
            tableData: []
        };
    },
    created() {
        let that=this
        that.id = that.$route.query.id;
        console.log(that.id);
        that.getSysInfoList();
    },
    methods: {
        getSysInfoList() {
            this.$axios
                .post('topic/getData', {
                    id: this.id
                })
                .then(res => {
                    console.log(res);
                    if (res.data.code == 0) {
                        this.tableData = res.data.data;
                        // this.$message.success('获取轮播图成功');
                    } else {
                        this.$message.error(res.data.data);
                    }
                });
        },
        returnPage() {
            // 跳转上一级
            // 这个判断用来解决这种情况，当用户没有上一条路由的历史记录，出现点击返回按钮没有反应时，下面的代码用来判断有没有上一条路由的历史记录   如果没有则返回首页
            if (window.history.length <= 1) {
                this.$router.push({ path: '/home' });
                return false;
            } else {
                this.$router.go(-1);
            }
        }
    }
};
</script>
<style scoped>
.el-button {
    margin-bottom: 20px;
    width: 80px;
    font-size: 14px;
    font-weight: bold;
}
.demo-image__lazy {
    text-align: center;
}
.avatar {
    width: 148px;
    height: 148px;
    display: block;
}
</style>
